/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
import queryString from 'query-string';
import { useNavigate, useLocation } from 'react-router-dom';
import { SpreadsheetImport } from '@vlinder-web/spreadsheet-import-widget-react';
import { VApplication } from '@/application';
import { BulkImportPageService } from '../services';
import { useSMCreateGroup } from '../machines/createGroup';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import toast from 'react-hot-toast';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.BulkImportPageService') as BulkImportPageService;
};

export const ContainerComm = (props: any) => {
  const [isWorkflowOpen, setWorkflowOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const parsed = queryString.parse(location.search);
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const { createGroupMachine, createGroupSend, createGroupState } =
    useSMCreateGroup({});

  if (
    createGroupState?.matches('CREATE_GROUP_SUCCESS') ||
    createGroupState?.matches('CREATE_GROUP_FAILED')
  ) {
    console.log(`createGroupState`, createGroupState);
    if (createGroupState?.matches('CREATE_GROUP_SUCCESS')) {
      toast.success('User imported successfully');
    } else if (createGroupState?.matches('CREATE_GROUP_FAILED')) {
      toast.error('User import failed');
    }

    navigate(-1);
  }

  const onSpreadsheetSubmit = (data: any) => {
    console.log(`excel submit`, data);
    if (isWorkflowOpen) {
      setWorkflowOpen(false);
    }
    navigate(-1);
    // createGroupSend('START', {
    //   payload: {
    //     ...(data || {}),
    //   },
    // });
  };

  console.log(
    `createGroupState outside`,
    createGroupState,
    createGroupState?.matches('idle')
  );

  const onSpreadsheetClose = (type?: string) => {
    console.log(`excel close`, type);
    if (isWorkflowOpen) {
      setWorkflowOpen(false);
      navigate(-1);
    }
    if (type === 'default') {
      navigate(-1);
    }
  };

  const rowHook = (data: any, addError: any) => {
    return { ...data, group: parsed?.groupId };
  };

  const _renderSpreadSheet = () => {
    return (
      <SpreadsheetImport
        isOpen={isWorkflowOpen}
        onSubmit={onSpreadsheetSubmit}
        onClose={onSpreadsheetClose}
        {...(staticPageContentConfig?.userListImport || {})}
        rowHook={rowHook}
      />
    );
  };

  const _renderLoadingPage = () => {
    if (createGroupState?.matches('CREATE_GROUP')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.bulkImportStudents || {})}
        />
      );
    }
  };

  return (
    <div>
      {_renderSpreadSheet()}
      {_renderLoadingPage()}
    </div>
  );
};
